<template>

    <nav aria-label="Breadcrumb">
        <ol class="breadcrumb small">
            <li class="me-2">
                {{ __('Sie sind hier:') }}
            </li>
            <li class="breadcrumb-item">
                <inertia-link :href="$page.props.app.url">
                    {{ __('Startseite') }}
                </inertia-link>
            </li>
            <li class="breadcrumb-item" :class="{active: index === items.length - 1}" v-for="(item, key, index) in unescapedItems">
                <inertia-link :href="item.url">
                    {{ item.label }}
                </inertia-link>
            </li>
        </ol>
    </nav>

</template>


<script>
    export default {
        props: {
            items: {
                type: Array,
                default: [],
            }
        },
        data() {
            return {

            }
        },
        computed: {
            unescapedItems() {
                return this.items.map(function(item) {
                    item.url = decodeURIComponent(item.url);
                    return item;
                });
            }
        },
    }
</script>